import request from '@/utils/request'

let Ma_departApi = {

  /*部门列表*/
  list(data) {
    return request._post('/shop/plus.ma_depart.Index/index', data);
},
/*添加部门*/
add(data) {
    return request._post('/shop/plus.ma_depart.Index/add', data);
},
/*修改部门*/
edit(data) {
    return request._post('/shop/plus.ma_depart.Index/edit', data);
},
/*删除部门*/
del(data) {
    return request._post('/shop/plus.ma_depart.Index/del', data);
},
/*部门详情*/
detail(data) {
  return request._post('/shop/plus.ma_depart.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.ma_depart.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.ma_depart.Setting/getSetting', data, errorback);
    },
}
export default Ma_departApi;



// WEBPACK FOOTER //
// ./src/api/ma_depart.js